module.exports = __webpack_public_path__ + "img/quanbu.7b5c7c49.png";